const FALLBACK_EXPIRY_YEARS = 100;

const toDateFromUnixSeconds = (unixSeconds) => {
  const timestamp = Number(unixSeconds);
  if (!Number.isFinite(timestamp)) return null;
  return new Date(timestamp * 1000);
};

export const getDefaultExternalVoucherExpiryDate = (baseDate = new Date()) => {
  const fallbackDate = new Date(baseDate);
  fallbackDate.setFullYear(fallbackDate.getFullYear() + FALLBACK_EXPIRY_YEARS);
  return fallbackDate;
};

export const getExternalVoucherExpiryDate = ({
  expiryDate,
  deadline,
  availableEnd,
} = {}) => {
  if (expiryDate) return expiryDate;
  if (deadline) return deadline;

  const availableEndDate = toDateFromUnixSeconds(availableEnd);
  if (availableEndDate) return availableEndDate;

  return getDefaultExternalVoucherExpiryDate();
};
